/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

const state = {
  slideIn: {},
  statusInfos: {},
  hasClearNonBtn: false,
  eventModifier: ""
}

const getters = {
  notificationStates: state => state
}

const mutations = {
  restoreStates(state, newStates) {
    for (const key in newStates) {
      state[key] = newStates[key]
    }
  },
  setSlideIn(state, data) {
    state.slideIn = data
  },
  setStatusInfos(state, data) {
    state.statusInfos = data
  },
  hasClearNonBtn(state, data) {
    state.hasClearNonBtn = data
  },
  setEventModifier(state, data) {
    state.eventModifier = data
  }
}

const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js